import { render, staticRenderFns } from "./Artilharia.vue?vue&type=template&id=40b4f17b"
import script from "./Artilharia.vue?vue&type=script&lang=js"
export * from "./Artilharia.vue?vue&type=script&lang=js"
import style0 from "./Artilharia.vue?vue&type=style&index=0&id=40b4f17b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports